import { render, staticRenderFns } from "./SortDropdown.vue?vue&type=template&id=6f1f8183&scoped=true&"
import script from "./SortDropdown.vue?vue&type=script&lang=js&"
export * from "./SortDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SortDropdown.vue?vue&type=style&index=0&id=6f1f8183&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f8183",
  null
  
)

export default component.exports